// todo: view hydration via backend session or localStorage
// should flow through here like middleware

export default ['$http', '$q', hydrate]

function hydrate($http, $q) {
  // const storage = window.localStorage
}
